export const LAYER_TYPE = {
    input: 0,
    hidden: 1,
    output: 2
};

export const TRAINING_STATUS = {
    waiting: 0,
    training: 1,
    finish: 2,
    canceled: 3,
    error: 4
};

export const INFERENCE_STATUS = {
    waiting: 0,
    inferencing: 1,
    success: 2,
    error: 3
};